// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 700) return "assets/dist/akbb/main.700.min.js";
	if (chunkId === 435) return "assets/dist/akbb/main.435.min.js";
	if (chunkId === 371) return "assets/dist/akbb/main.371.min.js";
	// return url for filenames based on template
	return undefined;
};